import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=60406362"
import script from "./ActivityList.vue?vue&type=script&lang=ts"
export * from "./ActivityList.vue?vue&type=script&lang=ts"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=60406362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports